<div class="container-fluid">
  <app-page-header
    icon="fe-briefcase"
    pretitle="Registo"
    [title]="isEdit() ? 'Editar organização' : 'Nova organização'"
    description="Defina o nome e os domínios de e-mail — clientes com esses domínios são associados automaticamente."
  >
    <a actions class="btn btn-outline-light" [routerLink]="['..']">
      <i class="fe fe-x me-1"></i> Cancelar
    </a>
  </app-page-header>
</div>

<div class="container-fluid">
  <form [formGroup]="form" (ngSubmit)="submit()">
    @if (error()) {
      <div class="alert alert-danger">{{ error() }}</div>
    }

    <div class="card">
      <div class="card-body">
        <div class="mb-3">
          <label class="form-label">Nome</label>
          <input class="form-control" formControlName="name" placeholder="Ex.: Acme Corporation" />
          @if (form.controls.name.touched && form.controls.name.invalid) {
            <small class="text-danger">O nome é obrigatório.</small>
          }
        </div>

        <div class="mb-3">
          <label class="form-label">Domínios de e-mail</label>
          <div class="tags-editor">
            @for (domain of domains(); track domain) {
              <span class="tag-chip">
                {{ domain }}
                <button type="button" class="tag-chip-remove" (click)="removeDomain(domain)" aria-label="Remover domínio">×</button>
              </span>
            }
            <input
              class="tags-input"
              [(ngModel)]="domainInput"
              [ngModelOptions]="{ standalone: true }"
              (keydown.enter)="$event.preventDefault(); addDomain()"
              placeholder="acme.com + Enter"
            />
          </div>
          <small class="text-muted">Clientes com e-mail nesses domínios serão vinculados a esta organização.</small>
        </div>

        <div class="mb-0">
          <label class="form-label">Notas</label>
          <textarea class="form-control" rows="4" formControlName="notes" placeholder="Observações internas…"></textarea>
        </div>
      </div>

      <div class="card-footer d-flex justify-content-end gap-2">
        <a class="btn btn-white" [routerLink]="['..']">Cancelar</a>
        <button type="submit" class="btn btn-primary" [disabled]="saving()">
          {{ saving() ? 'A guardar…' : 'Guardar' }}
        </button>
      </div>
    </div>
  </form>
</div>
